export let formataDataWebMethodParaDate = (dataASPNETWebMethod) => {
    if (!dataASPNETWebMethod) {
        return null;
    }
    //webapi 
    if (dataASPNETWebMethod.indexOf("T") > 0) {
        return new Date(dataASPNETWebMethod);
    }
    //mvc ou webmethod
    return new Date(+(dataASPNETWebMethod.replace(/\/Date\(/gim, "").replace(/(\)|\/)/gim, "")));
}

export let formataDataWebMethodParaString = (dataASPNETWebMethod) => {
    if (!dataASPNETWebMethod) {
        return "";
    }
    var d = formataDataWebMethodParaDate(dataASPNETWebMethod);

    var dia = d.getDate();
    var mes = d.getMonth() + 1;

    if (dia < 10) {
        dia = "0" + dia;
    }

    if (mes < 10) {

        mes = "0" + mes;
    }

    return dia + "/" + mes + "/" + d.getFullYear();

}

export let  tirarAcento = (texto) =>{
    var comAcentos = "ÑÄÅÁÂÀÃäáâàãÉÊËÈéêëèÍÎÏÌíîïìÖÓÔÒÕöóôòõÜÚÛüúûùÇçºª'´";
    var semAcentos = "NAAAAAAaaaaaEEEEeeeeIIIIiiiiOOOOOoooooUUUuuuuCc    ";
    texto = texto.trim();
    for (var i = 0; i < comAcentos.length; i++) {
        texto = texto.replace(new RegExp(comAcentos[i], "gm"), semAcentos[i]);
    }
    return texto;
}

//yyyy-MM-dd
export let formataDataWebMethodParaStringHTML5 = (dataASPNETWebMethod) => {
    if (!dataASPNETWebMethod) {
        return "";
    }
    var d = formataDataWebMethodParaDate(dataASPNETWebMethod);

    var dia = d.getDate();
    var mes = d.getMonth() + 1;

    if (dia < 10) {
        dia = "0" + dia;
    }

    if (mes < 10) {

        mes = "0" + mes;
    }

    return d.getFullYear() + "-" + mes + "-" + dia;

}
//yyyy-MM-dd -> dd/MM/yyyy
export let formataDataHTML5ParaDDMMYYYY = (dataHTML5) => {

    if (!dataHTML5) {
        return "";
    }

    return dataHTML5.split("-").reverse().join("/");

}

export let formataDataDDMMYYYYParaHTML5 = (dataDDMMYYYY) => {

    if (!dataDDMMYYYY) {
        return "";
    }

    return dataDDMMYYYY.split("/").reverse().join("-");

}

export let converteStringDataDDMMYYYYParaDate = (dataDDMMYYYY) => {

    if (!dataDDMMYYYY) {
        return new Date();
    }
    var temp = dataDDMMYYYY.split("/");
    var dia = Number(temp[0]);
    var mes = Number(temp[1]);
    var ano = Number(temp[2]);
    return new Date(ano, mes - 1, dia)

}


export let mascaraCelular9Digito = (v) => {
    if (!v) {
        return "";
    }
    v = v.replace(/\D/g, "");             //Remove tudo o que não é dígito
    if (v.length >= 11) {
        v = v.substring(0, 11);
    }
    v = v.replace(/^(\d{2})(\d)/g, "($1)$2"); //Coloca parênteses em volta dos dois primeiros dígitos
    v = v.replace(/(\d)(\d{4})$/, "$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos

    return v;

}




export let yearDifference = (date) => {
    "use strict";
    var curDate = new Date(),
        now = {
            year: curDate.getUTCFullYear(),
            // UTC month value is zero-based
            month: curDate.getUTCMonth(),
            day: curDate.getUTCDate()
        },
        diff = now.year % date.getUTCFullYear();

    // Do not update the date unless it is time
    if (now.month < date.getUTCMonth() ||
        now.month === date.getUTCMonth() && now.day < date.getUTCDate()) {
        diff -= 1;
    }

    return diff;
}

export let getParentesco = (value) => {
    var list = getListTipoParentesco();
    list = list.filter((item) => {
        return item.value === value;
    });
    if (list.length > 0) {
        return list[0];
    }

    return null;

};

export let getItemList = (list, value) => {

    var listTemp = list.filter((item) => {
        return item.value === value;
    });
    if (listTemp.length > 0) {
        return listTemp[0];
    }

    return null;

};





export let getListTipoParentesco = () => {
    return [
        {
            text: "Pai",
            value: 1
        },
        {
            text: "Padastro",
            value: 2
        },
        {
            text: "Mãe",
            value: 3
        },
        {
            text: "Madastra",
            value: 4
        },
        {
            text: "Cônjuge",
            value: 5
        },
        {
            text: "Companheiro(a)",
            value: 6
        },
        {
            text: "Filho(a)",
            value: 7
        },
        {
            text: "Enteado(a)",
            value: 8
        },
        {
            text: "Irmão",
            value: 9
        },
        {
            text: "Avô(ó)",
            value: 10
        }
    ];
};



export let formataCentavoZerado = (txtNum) => {
    var temp = txtNum && txtNum.toString() || "";
    //quando é backspace            
    //,00
    //,0
    var p = temp.lastIndexOf(",0");
    if (p >= 0 && p === temp.length - 2) {
        temp = temp.substr(0, temp.length - 3);
    }
    temp = temp.replace(/\,00/, "");
    temp = temp.replace(/[^\d]/gim, "");
    if (temp) {
        temp = temp + ",00";
    }

    return temp;
};


export let getListEscolaridade = () => {


    return [
        {
            text: "Educação Infantil",
            value: 10
        },
        {
            text: "Fundamental - Incompleto",
            value: 11
        },
        {
            text: "Fundamental - Completo",
            value: 12
        },
        {
            text: "Médio - Incompleto",
            value: 13
        },
        {
            text: "Médio - Completo",
            value: 1
        },
        {
            text: "Superior - Incompleto",
            value: 2
        },
        {
            text: "Superior - Completo",
            value: 3
        },
        {
            text: "Pós-graduação (Lato senso) - Incompleto",
            value: 4
        },
        {
            text: "Pós-graduação (Lato senso) - Completo",
            value: 5
        },
        {
            text: "Pós-graduação  (Stricto sensu, nível mestrado) - Incompleto",
            value: 6
        },
        {
            text: "Pós-graduação (Stricto sensu, nível mestrado) - Completo",
            value: 7
        },
        {
            text: "Pós-graduação (Stricto sensu, nível doutor) - Incompleto",
            value: 8
        },
        {
            text: "Pós-graduação (Stricto sensu, nível doutor) - Completo",
            value: 9
        }
    ];

};


// WEBPACK FOOTER //
// ./src/modules/util.js